document.addEventListener("DOMContentLoaded", (event) => {
	let configs = {}

	if (window.heroBannerAutoPlay) {
		configs = {...configs, autoplay: {
			delay: window.heroBannerSpeedAuto,
		}}
	}

	const sectionHeroBanners = document.querySelectorAll('.hn-hero-banner')
	if (sectionHeroBanners.length > 0) {
		sectionHeroBanners.forEach(section => {
			const sectionHeroBanner = new Swiper(section.querySelector('.hn-banner-swiper'), {
				loop: true,
				spaceBetween: 0,
				slidesPerView: 'auto',
				mousewheel: {
					forceToAxis: true,
					releaseOnEdges: true,
					sensitivity: 1,
					thresholdDelta: 40,
					thresholdTime: 200
				},
				navigation: {
					nextEl: section?.querySelector('.swiper-button-next'),
					prevEl: section?.querySelector('.swiper-button-prev'),
				},
				...configs,
				on: {
          init: function () {
            const currentSlide = document.getElementById('current-slide');
            if (currentSlide) {
              currentSlide.textContent = this.realIndex + 1;
            }
          },
          slideChange: function () {
            const currentSlide = document.getElementById('current-slide');
            if (currentSlide) {
              currentSlide.textContent = this.realIndex + 1;
            }
          }
        }
			})

			if (window.heroBannerAutoPlay) {
				section.querySelector('.hn-banner-swiper').addEventListener('mouseover', () => {
					sectionHeroBanner.autoplay.stop()
				})
	
				section.querySelector('.hn-banner-swiper').addEventListener('mouseout', () => {
					sectionHeroBanner.autoplay.start()
				})
			}
		})
	}
})
  